import {Component, EventEmitter, Input, OnInit, Output, Attribute, SimpleChanges} from '@angular/core';
import {KeyValuePipe, NgForOf, NgIf} from '@angular/common';
import {keys, isEmpty, forEach} from 'lodash-es';
import { getGroupedFields, isValidDataSet } from "@wms/core";
import { CommonWidgetDirective } from "@wms/directives";

@Component({
  standalone: true,
  selector: 'wms-order-by',
  templateUrl: './orderby.component.html',
  styleUrls: ['./orderby.component.less'],
  imports: [NgForOf, NgIf, KeyValuePipe, CommonWidgetDirective]
})
export class WMSOrderbyComponent implements OnInit {
  @Input() orderbyModel! : any;
  @Output() onFocus! : EventEmitter<any>;
  @Output() onChange! : EventEmitter<{orderbyModel : string}>;
  DESC_ORDER: string = "desc";
  ASC_ORDER: string = "asc";
  columns: any = {"all": {"keys": []}};
  orderbyModelObj : any;
  _keys: string[];
  _options: string[];

  get keys(){
    return this._keys;
  }

  @Input() set keys(newVal){
    //If keys are already passed, set the keys directly. Else, extract from thevdataset
    this._keys = newVal
    if (newVal && !isEmpty(newVal)) {
      this.columns = getGroupedFields(newVal, (this.groupFields === "true"));
    } else {
      this.resetModel();
    }
  }

  get options(){
    return this._options;
  }

  @Input() set options(newVal){
    if (isValidDataSet(newVal)) {
      this._options
      this.columns = getGroupedFields(newVal, (this.groupFields === "true"));
    } else {
      this.resetModel();
    }
  }
  /**
   * Get sort icon class name
   * @param key
   */
  getIconClass(key: any) : string {
    return "wms wms-arrow-" + (this.orderbyModelObj[key] === this.ASC_ORDER ? "up" : "down");
  }

  /**
   * Get if field is checked or not
   * @param item
   */
  isSelected(item : string) : boolean {
    return this.orderbyModelObj.hasOwnProperty(item);
  }

  /**
   * Emit focus event
   */
  handleFocus() : void {
    this.onFocus.emit();
  }

  /**
   * Update orderbyModelObj and call updateModel upon input type checkbox click
   * @param el
   */
  handleInputClick(el : EventTarget|null, item: string) : void {
    let elHTML = el as HTMLInputElement;
    let checked = elHTML.checked;
    if (item){
      if (checked) {
        let icon = elHTML.closest("li")?.querySelector("i");
        this.orderbyModelObj[item] = icon?.classList.contains("wms-arrow-down") ? this.DESC_ORDER : this.ASC_ORDER;
      }
      else if (!checked){
        delete this.orderbyModelObj[item];
      }
      this.updateModel();
    }
  }

  /**
   * Update orderbyModelObj with new sort order value upon sort order button click
   * @param el
   */
  handleButtonClick(el : EventTarget|null, item: string) : void {
    let elHTML = el as HTMLButtonElement;
    let icon = elHTML.querySelector("i");
    let after;
    if (icon && icon.classList.contains("wms-arrow-down")) {
      icon.classList.remove("wms-arrow-down");
      icon.classList.add("wms-arrow-up");
      after = this.ASC_ORDER;
    }
    else if (icon && icon.classList.contains("wms-arrow-up")) {
      icon.classList.remove("wms-arrow-up");
      icon.classList.add("wms-arrow-down");
      after = this.DESC_ORDER;
    }
    if (item) {
      this.orderbyModelObj[item] = after;
      this.updateModel();
    }
  }

  /**
   * Set columns, orderbyModel, orderbyModelObj to undefined
   */
  resetModel() : void {
    this.columns = undefined;
    this.orderbyModel = undefined;
    this.orderbyModelObj = undefined;
  }

  // Initialize and prepare orderbyModelObj from orderbyModel input value
  updateSelectedValuesFromModel(value?: any) {
    this.orderbyModelObj = {};
    if (this.orderbyModel) {
      this.orderbyModel.split(",").forEach((item : any) => {
        let values = item.trim().split(":");
        this.orderbyModelObj[values[0]] = values[1];
      });
    }
  }

  /**
   * Update orderbyModel by iterating orderbyModelObj and emit change event with orderbyModel value
   */
  updateModel() : void {
    this.orderbyModel = [];
    if(this.columns && this.orderbyModelObj) {
      forEach(keys(this.orderbyModelObj), key => {
        this.orderbyModel.push(key + ":" + this.orderbyModelObj[key]);
      });
    }
    this.orderbyModel = this.orderbyModel.join(",");
    this.onChange.emit({orderbyModel : this.orderbyModel});
  }

  constructor(@Attribute("group-fields") readonly groupFields : string, @Attribute("disabled") readonly disabled : string) {
    this.onFocus = new EventEmitter<any>();
    this.onChange = new EventEmitter<{orderbyModel : string}>();
  }

  ngOnInit(): void {
    this.updateSelectedValuesFromModel();
  }

  ngOnChanges(changes: SimpleChanges) {
    this.updateSelectedValuesFromModel();
  }
}
